import { leadershipImgs, s3Bucket } from ".";

export const scienceArr = () => [
    {
        name: "Sassan Saatchi, PhD",
        img: `${s3Bucket}ssaatchi.jpg`,
        title: "CEO, Co-founder, Chief Scientist",
    },
    {
        name: "Phil DeCola, PhD",
        img: leadershipImgs.phil,
        title: "Co-founder, Senior Scientist",
    },
    {
        name: "Stephen Hagen, PhD",
        img: leadershipImgs.stephen,
        title: "COO, Senior Scientist",
    },
    {
        name: "Chris Woodall, PhD",
        img: leadershipImgs.chris,
        title: "Director US Forest Science and Policy"
    },
    {
        name: "Lorena Alves, PhD",
        img: `${s3Bucket}lalves.jpg`,
        title: "Affiliated Research Scientist",
    },
    {
        name: "Griffin Carter",
        img: `${s3Bucket}gcarter.jpg`,
        title: "Data Scientist",
    },
    {
        name: "Cynthia Creze, PhD",
        img: `${s3Bucket}ccreze.jpeg`,
        title: "Affiliated Research Scientist",
    },
    {
        name: "Ricardo Dalagnol da Silva, PhD",
        img: `${s3Bucket}rsilva.jpg`,
        title: "Activity Data Science Lead",
    },
    {
        name: "Manoj Hari, PhD",
        img: `${s3Bucket}mhari.JPG`,
        title: "Affiliated Research Scientist",
    },
    {
        name: "Mayumi Hirye, PhD",
        img: `${s3Bucket}mhirye.jpg`,
        title: "Affiliated Research Scientist",
    },
    {
        name: "Wen Tao Lin",
        img: `${s3Bucket}wliu.jpg`,
        title: "Data Scientist",
    },
    {
        name: "Zhihua Liu, PhD",
        img: `${s3Bucket}zliu.jpg`,
        title: "Research Scientist",
    },
    {
        name: "Chris Mihiar, PhD",
        img: `${s3Bucket}CMihiar.png`,
        title: "Product Lead",
    },
    {
        name: "Adugna Mullissa, PhD",
        img: `${s3Bucket}amullissa.jpg`,
        title: "Radar Science Lead",
    },
    {
        name: "Fiona Osborn",
        img: `${s3Bucket}fosborn.jpg`,
        title: "Senior Data Analyst",
    },
    {
        name: "Le Bienfaiteur Sagang, PhD",
        img: `${s3Bucket}lsagang.jpg`,
        title: "Affiliated Research Scientist",
    },
    {
        name: "Fabien Wagner, PhD",
        img: `${s3Bucket}fwagner.jpg`,
        title: "Tree-level Data Science Lead",
    },
    {
        name: "Yan Yang, PhD",
        img: `${s3Bucket}yyang.jpg`,
        title: "Carbon Science Lead",
    },
    {
        name: "Dafeng Zhang, PhD",
        img: `${s3Bucket}dzhang.jpg`,
        title: "Affiliated Research Scientist",
    },
];
